/* GoldSupply - the live gold price strip, and the single source of the live
   spot price for the whole page.

   The markup lives in snippets/gold-price.liquid, which loads this with a
   deferred script tag built from  'gs-strip.js' | asset_url  and loads
   gs-strip.css beside it. Read the comment at the top of that snippet first:
   it explains the licence separation between the live supplier price and the
   World Bank chart, which this file must preserve.

   That tag is described rather than written out because a literal closing
   script tag inside this comment would end the element early for anything
   that inlines this file, dumping the rest of the code onto the page as
   text. Harmless while it is loaded as an external asset, which is how the
   theme loads it - but it cost half an hour to find in a test harness that
   did inline it, so it is not written out here.

   DEFER IS DELIBERATE. A deferred script runs after the document has been
   parsed, so .gs-tick exists, and so do the product cards further down the
   page that fillPremiums() fills in. That is strictly better than the inline
   version this replaced, which ran before the cards existed and had to wait
   for DOMContentLoaded to catch them. The readyState check at the bottom is
   kept anyway: it costs nothing and it still does the right thing. */

(function () {
  var root = document.querySelector('.gs-tick');
  if (!root) { return; }

  var base = root.getAttribute('data-gs-endpoint');
  var bar = root.querySelector('.gs-tick-bar');
  var panel = root.querySelector('.gs-tick-panel');
  var ozEl = root.querySelector('[data-gs-oz]');
  var gEl = root.querySelector('[data-gs-g]');
  var ageEl = root.querySelector('[data-gs-age]');

  var OZ_G = 31.1034768;
  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var NS = 'http://www.w3.org/2000/svg';

  var lastAsk = null, lastAsOf = null, timer = null;

  function money(n, dp) {
    return n.toLocaleString('en-US', { minimumFractionDigits: dp, maximumFractionDigits: dp });
  }
  function ago(iso) {
    var s = Math.max(0, Math.round((Date.now() - Date.parse(iso)) / 1000));
    if (s < 90) { return s + ' seconds ago'; }
    var m = Math.round(s / 60);
    if (m < 90) { return m + ' minutes ago'; }
    return Math.round(m / 60) + ' hours ago';
  }

  /* Fill every premium element on the page from one spot reading. Safe to call
     repeatedly; it is called on DOMContentLoaded and on every refresh. */
  function fillPremiums(spot) {
    if (!(spot > 0)) { return; }
    var els = document.querySelectorAll('[data-gs-prem]'), i, el, oz, price, melt, prem, pct;
    for (i = 0; i < els.length; i++) {
      el = els[i];
      oz = parseFloat(el.getAttribute('data-gs-oz'));
      price = parseFloat(el.getAttribute('data-gs-price'));
      if (!(oz > 0) || !(price > 0)) { continue; }
      melt = oz * spot;
      prem = price - melt;
      pct = prem / melt * 100;
      el.className = 'gs-prem' + (prem < 0 ? ' is-under' : '');
      el.innerHTML = '<span class="gs-prem-melt">Metal $' + money(melt, 0) + '</span>' +
        '<span class="gs-prem-sep">&middot;</span>' +
        (prem < 0
          ? '<span class="gs-prem-v">$' + money(-prem, 0) + ' below melt value</span>'
          : '<span class="gs-prem-v">$' + money(prem, 0) + ' over spot</span>' +
            '<span class="gs-prem-pct">(' + pct.toFixed(1) + '%)</span>');
      el.hidden = false;
    }
  }

  function showPrice(ask) {
    ozEl.textContent = '$' + money(ask, 2);
    gEl.textContent = '$' + money(ask / OZ_G, 2);
  }
  function failPrice() {
    ozEl.textContent = '--';
    gEl.textContent = '--';
    ageEl.textContent = 'Price feed unavailable';
  }

  function loadSpot() {
    return fetch(base + '/spot', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.status === 'ok' && typeof d.ask === 'number') {
          lastAsk = d.ask;
          lastAsOf = d.asOf;
          showPrice(d.ask);
          if (d.asOf) { ageEl.textContent = 'Updated ' + ago(d.asOf); }
          fillPremiums(d.ask);
          return d.ask;
        }
        failPrice();
        return null;
      })
      .catch(function () { failPrice(); return null; });
  }

  /* ---------- the chart ----------
     World Bank monthly averages, the same series and the same visual language
     as the home page chart. The live supplier price is NOT repeated in here;
     see the licence note at the top of this file. */
  var data = null, range = 61, unit = 'oz', shape = null, loading = false;
  var WIDE = { W: 1000, H: 300, PL: 8, PR: 8, PT: 24, PB: 34, XL: 6 };
  var NARROW = { W: 520, H: 430, PL: 6, PR: 6, PT: 22, PB: 46, XL: 3 };

  function q(sel) { return root.querySelector(sel); }
  function pickShape() {
    return (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) ? NARROW : WIDE;
  }
  function conv(v) { return unit === 'g' ? v / OZ_G : v; }

  /* A "nice" axis step that works for both scales. Per ounce the spread is in
     the hundreds; per gram it is roughly a thirty-first of that, so a fixed
     list of ounce-sized steps would give one gridline or forty. */
  function niceStep(spread, want) {
    if (!(spread > 0)) { return 1; }
    var raw = spread / want;
    var mag = Math.pow(10, Math.floor(Math.log(raw) / Math.LN10));
    var n = raw / mag;
    var mult = n <= 1 ? 1 : n <= 2 ? 2 : n <= 2.5 ? 2.5 : n <= 5 ? 5 : 10;
    return mult * mag;
  }
  function axisFmt(v, step) {
    var dp = step >= 10 ? 0 : step >= 1 ? 1 : 2;
    return '$' + v.toLocaleString('en-US', { minimumFractionDigits: dp, maximumFractionDigits: dp });
  }
  function label(ym, yearOnly) {
    var p = ym.split('-');
    return yearOnly ? p[0] : MONTHS[parseInt(p[1], 10) - 1] + ' ' + p[0].slice(2);
  }
  function empty(g) { while (g.firstChild) { g.removeChild(g.firstChild); } }
  function textNode(cls, x, y, anchor, str) {
    var t = document.createElementNS(NS, 'text');
    t.setAttribute('class', cls);
    t.setAttribute('x', x); t.setAttribute('y', y);
    if (anchor) { t.setAttribute('text-anchor', anchor); }
    t.textContent = str;
    return t;
  }

  function draw() {
    if (!data || data.length < 2) { return; }
    shape = pickShape();
    var svg = q('[data-tk-svg]');
    svg.setAttribute('viewBox', '0 0 ' + shape.W + ' ' + shape.H);

    var series = data.slice(Math.max(0, data.length - range));
    if (series.length < 2) { return; }

    var lo = conv(series[0][1]), hi = lo, i, v;
    for (i = 0; i < series.length; i++) {
      v = conv(series[i][1]);
      if (v > hi) { hi = v; }
      if (v < lo) { lo = v; }
    }
    var st = niceStep(hi - lo, 4);
    var baseV = Math.floor(lo / st) * st;
    var topV = Math.ceil(hi / st) * st;
    if (topV === baseV) { topV = baseV + st; }

    var X = function (k) {
      return series.length === 1 ? shape.PL
        : shape.PL + (shape.W - shape.PL - shape.PR) * (k / (series.length - 1));
    };
    var Y = function (val) {
      return shape.PT + (shape.H - shape.PT - shape.PB) * (1 - (val - baseV) / (topV - baseV));
    };

    var d = '';
    for (i = 0; i < series.length; i++) {
      d += (i === 0 ? 'M' : 'L') + X(i).toFixed(1) + ' ' + Y(conv(series[i][1])).toFixed(1) + ' ';
    }
    q('[data-tk-line]').setAttribute('d', d);
    q('[data-tk-area]').setAttribute('d', d + 'L' + X(series.length - 1).toFixed(1) + ' ' +
      (shape.H - shape.PB) + 'L' + shape.PL + ' ' + (shape.H - shape.PB) + 'Z');

    var dot = q('[data-tk-dot]');
    dot.setAttribute('cx', X(series.length - 1).toFixed(1));
    dot.setAttribute('cy', Y(conv(series[series.length - 1][1])).toFixed(1));

    var grid = '', ylabs = q('[data-tk-ylabs]');
    empty(ylabs);
    /* Step through gridlines by index, not by repeatedly adding a float to
       itself - 2.5 added twenty times drifts and can skip the top line. */
    var lines = Math.round((topV - baseV) / st);
    for (i = 0; i <= lines; i++) {
      v = baseV + i * st;
      grid += 'M' + shape.PL + ' ' + Y(v).toFixed(1) + 'L' + (shape.W - shape.PR) + ' ' + Y(v).toFixed(1) + ' ';
      ylabs.appendChild(textNode('gs-tk-ylab', shape.PL + 4, (Y(v) - 5).toFixed(1), null, axisFmt(v, st)));
    }
    q('[data-tk-grid]').setAttribute('d', grid);

    var yearOnly = series.length > 30;
    var want = Math.min(shape.XL, series.length);
    var xlabs = q('[data-tk-xlabs]');
    empty(xlabs);
    var seen = {}, k, str, anchor;
    for (i = 0; i < want; i++) {
      k = want === 1 ? 0 : Math.round(i * (series.length - 1) / (want - 1));
      str = label(series[k][0], yearOnly);
      if (seen[str]) { continue; }
      seen[str] = 1;
      anchor = i === 0 ? 'start' : (i === want - 1 ? 'end' : 'middle');
      xlabs.appendChild(textNode('gs-tk-xlab', X(k).toFixed(1), shape.H - 12, anchor, str));
    }

    var first = series[0][1], last = series[series.length - 1][1];
    var pct = (last / first - 1) * 100;
    /* The percentage change is identical in either unit - dividing both ends by
       31.1034768 cancels - so the toggle changes the axis, never the story. */
    q('[data-tk-span]').textContent = label(series[0][0], false) + ' to ' + label(series[series.length - 1][0], false);
    q('[data-tk-chg]').textContent = (pct >= 0 ? 'up ' : 'down ') + Math.abs(pct).toFixed(1) + '% over this period';
  }

  function loadChart() {
    if (data || loading) { draw(); return; }
    loading = true;
    fetch(base + '/spot/monthly')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        loading = false;
        if (!d || !d.points || d.points.length < 2) {
          q('[data-tk-source]').textContent = 'The price history is unavailable right now.';
          return;
        }
        data = d.points;
        if (d.source) { q('[data-tk-source]').textContent = d.source + '.'; }
        draw();
      })
      .catch(function () {
        loading = false;
        q('[data-tk-source]').textContent = 'The price history is unavailable right now.';
      });
  }

  /* ---------- controls ---------- */
  function group(sel, apply) {
    var btns = root.querySelectorAll(sel);
    Array.prototype.forEach.call(btns, function (b) {
      b.addEventListener('click', function () {
        Array.prototype.forEach.call(btns, function (o) { o.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        apply(b);
        draw();
      });
    });
    return btns;
  }
  group('[data-tk-range]', function (b) { range = parseInt(b.getAttribute('data-tk-range'), 10); });
  var unitBtns = group('[data-tk-unit]', function (b) {
    unit = b.getAttribute('data-tk-unit');
    /* A per-viewer convenience only. It never leaves this browser, so it is
       wrapped - private windows and blocked site data both throw here. */
    try { localStorage.setItem('gs-chart-unit', unit); } catch (e) {}
  });
  try {
    var saved = localStorage.getItem('gs-chart-unit');
    if (saved === 'g' || saved === 'oz') {
      unit = saved;
      Array.prototype.forEach.call(unitBtns, function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-tk-unit') === unit ? 'true' : 'false');
      });
    }
  } catch (e) {}

  function open() { panel.hidden = false; bar.setAttribute('aria-expanded', 'true'); loadChart(); }
  function close() { panel.hidden = true; bar.setAttribute('aria-expanded', 'false'); }
  bar.addEventListener('click', function () { if (panel.hidden) { open(); } else { close(); } });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { close(); } });

  /* ---------- scrolling closes the chart ----------
     The strip is position:sticky (assets/gs-strip.css), so whatever height it
     has is what follows the reader down the page. Closed that is 47px, which
     is the point. OPEN IT IS ABOUT 580px - two thirds of a laptop viewport -
     and pinning that would bury the page behind the very thing the reader
     scrolled past it to reach. Measured at 1440x900 before this was added.

     So a scroll closes the panel: the price stays, the chart tucks away, and
     the bar opens it again. Opening does not scroll, so this never fires on
     the click that opened it. The listener is passive - it never calls
     preventDefault - so it cannot slow scrolling, and it does nothing at all
     while the panel is already closed. */
  window.addEventListener('scroll', function () {
    if (!panel.hidden) { close(); }
  }, { passive: true });

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (resizeTimer) { clearTimeout(resizeTimer); }
    resizeTimer = setTimeout(function () { if (pickShape() !== shape) { draw(); } }, 180);
  });

  /* ---------- polling ----------
     Spot is polled for the whole page, not just while the panel is open,
     because every [data-gs-prem] element depends on it. 60s is deliberate: the
     feed reports its own age at roughly 195s, so polling faster only burdens
     the service for a number that has not changed. Paused while the tab is in
     the background so an abandoned tab stops calling the server. */
  function startPoll() { if (!timer) { timer = setInterval(loadSpot, 60000); } }
  function stopPoll() { if (timer) { clearInterval(timer); timer = null; } }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { stopPoll(); } else { loadSpot(); startPoll(); }
  });

  loadSpot();
  startPoll();
  /* The product cards do not exist yet - see the ordering note at the top. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { fillPremiums(lastAsk); });
  } else {
    fillPremiums(lastAsk);
  }
})();
